var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-list',{staticClass:"bg-transparent !flex flex-col items-center"},[_c('ProfileFilter',{attrs:{"dialog":_vm.filterDialog},on:{"close-dialog":function($event){_vm.filterDialog = false}}}),_vm._l((_vm.navItem),function(item,i){return _c('v-list-item',{directives:[{name:"motion",rawName:"v-motion"}],key:item.name,staticClass:"mb-2",attrs:{"initial":{
        x: 100,
        opacity: 0,
      },"enter":{
  x: 0,
  opacity: 1,
  transition: {
    duration: 300,
    type: 'keyframes',
    ease: 'backOut',
    delay: `${i}00`,
  },
}}},[_c('NavButton',{attrs:{"iconName":item.iconName,"name":item.name,"link":item.link,"badge":item.badge,"badgeContent":item.badgeContent},on:{"callFunction":function($event){return _vm.fn_handle(item.click)}}})],1)})],2),_c('SubscribePremiumDialog')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }